<input
  class="form-control"
  type="text"
  [mask]="this.entityMaskType(this.companyFormComponent.model.country, this.companyFormComponent.model.businessAccount)"
  [placeholder]="this.entityMaskType(this.companyFormComponent.model.country, this.companyFormComponent.model.businessAccount)"
  [dropSpecialCharacters]="false"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
